import React from "react";

const ImportCommonAction = ({ onClick, title }) => {
  return (
    <button
      type="button"
      onClick={() => onClick()}
      className="btn btn-outline-primary waves-effect waves-light"
    >
      <i className="mdi mdi-file-import"></i> Import {title}
    </button>
  );
};

export default ImportCommonAction;
